/**
 * DangerZoneSection - Danger zone card with the delete account action
 */

import { useTranslation } from 'react-i18next';

interface DangerZoneSectionProps {
  onDeleteClick: () => void;
}

export default function DangerZoneSection({ onDeleteClick }: DangerZoneSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-danger/5 border border-danger/30 rounded-xl p-6 mt-6">
      <h3 className="font-sans font-semibold text-danger mb-2">{t('profilePage.dangerZone')}</h3>
      <p className="text-sm text-ink-muted mb-4">
        {t('profilePage.deleteWarning')}
      </p>
      <button
        onClick={onDeleteClick}
        className="px-4 py-2 bg-danger text-white text-sm font-semibold rounded-lg hover:bg-danger/90 transition-colors"
      >
        {t('deleteAccount.cancelButton')}
      </button>
    </div>
  );
}
